<template>
  <div>
    <ComfortLoanApplicationTimeline v-if="application.productType === 'COMFORT'" :application="application"/>
    <RegularLoanApplicationTimeline v-else :show-future="showFuture" :application="application"/>
  </div>
</template>

<script>
  import ComfortLoanApplicationTimeline from '@shared/components/timeline/ComfortLoanApplicationTimeline'
  import RegularLoanApplicationTimeline from '@shared/components/timeline/RegularLoanApplicationTimeline'

  export default {
    name: 'LoanApplicationTimeline',
    components: {
      RegularLoanApplicationTimeline,
      ComfortLoanApplicationTimeline
    },
    props: ['application', 'showFuture']
  }
</script>
